import { useEffect, useState } from 'react';
import { getPendingConversion } from '../services';
import { IPendingConversionData, HookState } from '../types';
import { resolveErrorMessage } from './hookUtils';

export function usePendingConversion(options?: {
	sellerId?: number;
	team?: string;
	bucket?: string;
	limit?: number;
	offset?: number;
}): HookState<IPendingConversionData> {
	const [state, setState] = useState<HookState<IPendingConversionData>>({
		data: null,
		loading: true,
		error: null,
		cachedAt: null,
	});

	const sellerId = options?.sellerId;
	const team = options?.team;
	const bucket = options?.bucket;
	const limit = options?.limit ?? 50;
	const offset = options?.offset ?? 0;

	useEffect(() => {
		let cancelled = false;
		const controller = new AbortController();
		setState((prev) => ({ ...prev, loading: true, error: null }));

		getPendingConversion({ sellerId, team, bucket, limit, offset })
			.then(({ data, cachedAt }) => {
				if (!cancelled) setState({ data, loading: false, error: null, cachedAt });
			})
			.catch((err) => {
				if (!cancelled && !controller.signal.aborted)
					setState({ data: null, loading: false, error: resolveErrorMessage(err), cachedAt: null });
			});

		return () => {
			cancelled = true;
			controller.abort();
		};
	}, [sellerId, team, bucket, limit, offset]);

	return state;
}
